/*
  Change position for video (metafield guru app)
  implemented: layout/theme.liquid
  Mobile and Desktop: below featured bulletes
*/
document.addEventListener("DOMContentLoaded", function () {

  const stylestixVideo = document.querySelector('[data-js-stylestix-video]')
  const desktopContainer = document.querySelector('[data-js-stylestix-video-container-desktop]')
  const isDesktop = window.innerWidth >= 768

   if(isDesktop && stylestixVideo){
    desktopContainer?.appendChild(stylestixVideo)
    stylestixVideo?.classList?.remove('hide')
    return
  }  
  
})